import { InputText } from '@fattureincloud/fic-design-system'
import { InputHelperProps } from '@fattureincloud/fic-design-system/dist/components/form/inputHelper'
import React, { FC, useEffect, useState } from 'react'

import { locale } from '../../locales/locale'
import { HelpModal } from '../common.components'

interface Props {
  onClose: () => void
  addArticle: (title: string) => void
}

const AddArticleModal: FC<Props> = (props: Props) => {
  const [newTitle, setNewTitle] = useState<string>('')
  const [helper, setHelper] = useState<InputHelperProps>(undefined)
  const defaultHelper = {
    message:
      locale("Il titolo verrà utilizzato per creare il permalink.") + ' ' +
      locale("L'articolo viene creato di default come bozza."),
    status: 'info',
  }

  useEffect(() => {
    setHelper(defaultHelper)
  }, [])

  const checkTitleError = () => {
    if (newTitle.length === 0) {
      setHelper({ message: locale('Inserisci un titolo'), status: 'error' })
      return true
    }
    setHelper(defaultHelper)
    return false
  }

  return (
    <HelpModal
      title={locale('Nuovo Articolo')}
      onActionClose={props.onClose}
      footerButtons={[
        {
          text: locale('Salva'),
          color: 'green',
          onClick: () => {
            if (!checkTitleError()) props.addArticle(newTitle)
          },
        },
      ]}
    >
      <InputText
        value={newTitle}
        label={locale('Titolo')}
        onChange={(e) => {
          setNewTitle(e.target.value)
        }}
        helper={helper}
      />
    </HelpModal>
  )
}

export default AddArticleModal
